import React from 'react';
import { useLocation } from 'react-router-dom';
import { HiUserCircle } from "react-icons/hi2";

const TopBar = () => {
  const location = useLocation();

  // Leer el nombre del usuario desde localStorage
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const userName = user.nombre_usuario || 'Invitado';

  // Obtener el nombre de la página actual basado en la ruta
  const getPageName = () => {
    switch (location.pathname) {
      case '/habitaciones':
        return 'Habitaciones';
      case '/reservas':
        return 'Reservas';
      case '/reservasvisualizador':
        return 'Visualizador de Reservas';
      case '/informes':
        return 'Informes';
        case '/reservas_usuario':
          return 'Mis reservas';
      case '/crear_usuarios':
        return 'Crear Usuario';
      default:
        return 'Reservas';
      case '/EditarReserva':
        return 'Editar Reserva';  
    }
  };

  return (
    <div
      style={{
        height: '65px', // Altura de la barra
        backgroundColor: '#333',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between', // Elementos en extremos
        padding: '0 20px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        position: 'relative', // Relativo para posicionar el texto en el medio
      }}
    >
      {/* Elemento invisible para ocupar espacio en la izquierda */}
      <div style={{ width: '150px' }}></div>

      {/* Nombre de la página centrado */}
      <div
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)', // Centrado horizontal
          fontWeight: 'bold',
          fontSize: '22px',
          whiteSpace: 'nowrap', // Evita que el texto se corte
        }}
      >
        {getPageName()}
      </div>

      {/* Información del usuario alineada a la derecha */}
      <div style={{ fontSize: '16px', textAlign: 'right', width: '150px' }}>
      <HiUserCircle fontSize={30}/> <div position="relative">{userName}</div>
      </div>
    </div>
  );
};

export default TopBar;




